import Mousetrap from 'mousetrap'

angular
  .module('deskfy.arts')
  .controller('UserArtsController', UserArtsController)

const SECTION_CONTENT_TYPE = {
  TEMPLATES: 'templates',
  COLLECTIONS: 'collections'
}

/* @ngInject */
function UserArtsController ($rootScope, $scope, $q, $timeout, $window, $state, $stateParams, $translate, $cookies, $location, ArtCollectionsService, ArtsService, ToastService, SegmentService, UdsModalService, LocalStorageService, SocialMediaService, AssetPreviewService, TemplateService, SelectMaterialCollectionService) {
  const getSocialMediaIntegrationUserController = () => $q.when(import('../../../dialogs/social-media-integration-user/social-media-integration-user.controller'))
  const getSocialMediaIntegrationUserExpiryController = () => $q.when(import('../../../dialogs/social-media-integration-user-expiry/social-media-integration-user-expiry.controller'))
  const getSocialMediaLinkedController = () => $q.when(import('../../../dialogs/social-media-linked/social-media-linked.controller'))

  $scope.breadcrumbs = { items: [] }
  $scope.search = {
    filters: [],
    state: {
      loading: false,
      searching: false
    },
    templates: {
      results: [],
      pagination: {
        top: 20,
        skip: 0
      },
      totalCount: 0
    },
    collections: {
      results: [],
      pagination: {
        top: 20,
        skip: 0
      },
      totalCount: 0
    }
  }

  $scope.news = {
    state: {
      loading: true
    },
    pagination: {
      $top: 4
    },
    results: [],
    hideBanner: !!Number($cookies.get('userArts.news.hideBanner')),
    totalCount: 0
  }
  $scope.sections = {
    results: {},
    presentationOrder: [],
    totalCount: 0,
    state: {
      loading: true
    },
    pagination: {
      section: {
        top: 10,
        skip: 0
      },
      templates: {
        top: 8
      },
      collections: {
        top: 8
      }
    }
  }
  $scope.highlightedCollections = {
    state: {
      loading: true
    },
    pagination: {
      top: 40
    },
    results: [],
    totalCount: 0
  }

  $scope.selectedTemplates = []
  $scope.selectedCollections = []

  $scope.disabledTemplatesRule = null
  $scope.floatingBarLocation = 'userArts'

  const api = {
    getSocialMediaIntegrationUserController,
    getSocialMediaIntegrationUserExpiryController,
    getSocialMediaLinkedController,
    _initCarousel,
    _loadSections,
    _loadNewTemplates,
    _loadSectionValues,
    _loadHighlightedCollections,
    _normalizeSectionValues,
    _getSectionValues,
    _showSocialMediaIntegrationModal,
    _openSocialMediaIntegrationUser,
    _openSocialMediaIntegrationUserExpiry,
    _checkSocialMediaIntegrationStatus,
    _openSocialMediaLinked,
    _handleDamMigrationRedirect,
    _clearAllSelections,
    _clearSelectedTemplate,
    _getSelectedTemplateSection,
    _handleLoadMoreSectionContent,
    _handleKeyboardNavigation,
    _handleNavigateThroughKeyboard,
    _defineDisabledTemplatesRule
  }
  this.getApi = () => api

  function _clearAllSelections (templates) {
    if (templates && templates.length > 0) {
      templates.forEach(t => {
        if (t) {
          t.selected = false
        }
      })
    }
  }

  activate()
  function activate () {
    SegmentService.track('arts-template-pageview')

    api._loadHighlightedCollections()
    api._loadNewTemplates()
    api._loadSections()
    api._handleKeyboardNavigation()

    if ($stateParams.previewId) {
      TemplateService.getTemplateById($stateParams.previewId).then((template) => {
        AssetPreviewService.openAssetPreview({
          asset: template
        })
      })
      delete $stateParams.previewId
    }

    $timeout(() => {
      $scope.$parent.sidebar.selectedMenuId = 1
      $window.scrollTo(0, 0)
    }, 100)

    api._showSocialMediaIntegrationModal()
    api._checkSocialMediaIntegrationStatus()
    api._openSocialMediaIntegrationUserExpiry()
  }

  $scope.$on('$destroy', () => {
    Mousetrap.unbind('space')
    document.removeEventListener('click', api._clearSelectedTemplate)
    AssetPreviewService.closePreview()
    document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
  })

  function _handleDamMigrationRedirect () {
    $timeout(() => {
      const sections = Object.entries($scope.sections.results).map(([key, value]) => value)
      const filesSection = sections.find(section => section.title === 'Arquivos')

      if (filesSection) {
        $('#' + filesSection.id)[0].scrollIntoView()
      }
    }, 500)
  }

  $scope.hasSectionsToShow = () => Object.keys($scope.sections.results).length > 0
  $scope.sectionHasMoreItemsToShow = (sectionId) => {
    const sectionTotalCount = ($scope.sections.results[sectionId]?.collections?.totalCount ?? 0) + ($scope.sections.results[sectionId]?.templates?.totalCount ?? 0)
    const sectionResultCount = ($scope.sections.results[sectionId]?.collections.results?.length ?? 0) + ($scope.sections.results[sectionId]?.templates.results?.length ?? 0)
    return sectionTotalCount > sectionResultCount
  }

  $scope.hasSomethingLoading = () => {
    return $scope.sections.state.loading || $scope.news.state.loading || $scope.highlightedCollections.state.loading
  }

  $scope.loadMore = function (sectionId) {
    api._handleLoadMoreSectionContent(sectionId)
  }

  /**
   * Handle load more section content.
   * @param {number} sectionId Section id.
   */
  function _handleLoadMoreSectionContent (sectionId) {
    const section = $scope.sections.results[sectionId]
    api._loadSectionValues(section)
      .catch((error) => {
        console.error({ error })
        ToastService.showErrorToast($translate.instant('userArts.sections.error'))
      })
  }

  $scope.handleOpenNewsLanding = () => {
    $state.go('user.latestNews')
  }

  $scope.handleHideBanner = () => {
    $scope.news.hideBanner = true
    $cookies.put('userArts.news.hideBanner', 1)
  }

  $scope.handleHighlightedCollectionClick = function (highlightedCollection) {
    $state.go('user.collection', { id: highlightedCollection.id }, { reload: true })
  }

  /**
   * Handle section expand click.
   * @param {number} sectionId Section id.
   */
  $scope.handleSectionExpandClick = function (sectionId) {
    $scope.sections.results[sectionId].isExpanded = !$scope.sections.results[sectionId].isExpanded
  }

  /**
   * Handle load more sections.
   */
  $scope.handleLoadMoreSections = function () {
    api._loadSections()
  }

  /**
   * Handle filters change of <user-search-bar> component and apply to search subcomponent.
   */
  $scope.handleFilterChange = function (filters) {
    $scope.search = {
      ...$scope.search,
      filters,
      state: {
        loading: Object.keys(filters).length > 0,
        searching: Object.keys(filters).length > 0
      }
    }

    if ($scope.search.state.searching) {
      const getNormalizedTrackingValue = (value) => {
        if (!value) return
        if (Array.isArray(value)) return value.join(',')
        return value
      }
      SegmentService.track('arts-search-module', {
        search_text: filters.query,
        search_level: getNormalizedTrackingValue(filters?.customizationLevel),
        search_format: getNormalizedTrackingValue(filters?.formatIds),
        search_approval: getNormalizedTrackingValue(filters?.needApproval),
        search_category: getNormalizedTrackingValue(filters?.tagIds),
        search_campaign: getNormalizedTrackingValue(filters?.campaignId)
      })
    }
  }

  $scope.onCollectionCardClick = function (collection, event) {
    const isShiftPressed = event && event.shiftKey

    if (collection.selected) {
      collection.firstSelection = false
      collection.selected = false
      $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
    } else {
      if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
        collection.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnCollection(collection, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          sections: Object.values($scope.sections.results),
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates
        return
      }

      collection.selected = true
      $scope.selectedCollections.push(collection)
    }
  }

  $scope.handleTemplateClick = function (template, event) {
    const isShiftPressed = event && event.shiftKey

    if (template.selected) {
      template.selected = false
      $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
    } else {
      if ($scope.selectedTemplates.length === 0) {
        template.firstSelection = true
      }

      if (isShiftPressed) {
        const { selectedCollections, selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnMaterial(template, {
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections,
          sections: Object.values($scope.sections.results),
          disabledTemplatesRule: $scope.disabledTemplatesRule
        })

        $scope.selectedCollections = selectedCollections
        $scope.selectedTemplates = selectedTemplates
        api._defineDisabledTemplatesRule()
        return
      }

      template.selected = true
      if (!$scope.selectedTemplates.some(t => t.id === template.id)) {
        $scope.selectedTemplates.push(template)
      }
    }

    api._defineDisabledTemplatesRule()
  }

  $scope.isTemplateDisabled = function (template) {
    if ($scope.disabledTemplatesRule === 'ALL' && $scope.selectedTemplates.length) {
      return template.id !== $scope.selectedTemplates[0].id
    } else if ($scope.disabledTemplatesRule === 'CUSTOMIZABLE') {
      return template.isCustomizable && template.customizationLevel !== 'ONLY_DOWNLOAD'
    }

    return false
  }

  $scope.unselectAllAssets = () => {
    $scope.selectedTemplates.forEach(template => {
      template.firstSelection = false
      template.selected = false
    })

    $scope.selectedCollections.forEach(collection => {
      collection.firstSelection = false
      collection.selected = false
    })

    $scope.selectedTemplates = []
    $scope.selectedCollections = []

    api._defineDisabledTemplatesRule()
  }
  /**
   * Initialize carousel to show highlighted collections.
   */
  function _initCarousel () {
    if (!$scope.highlightedCollections.results.length) return
    const carouselElement = document.querySelector('swiper-container')
    if (!carouselElement) return
    const carouselParams = {
      observer: true,
      spaceBetween: 10,
      slidesPerView: 'auto',
      observeParents: true,
      observeSlideChildren: true,
      breakpointsBase: 'container',
      navigation: {
        nextEl: '.carousel-next-button',
        prevEl: '.carousel-prev-button'
      },
      pagination: {
        clickable: true
      }
    }

    Object.assign(carouselElement, carouselParams)
    carouselElement.initialize()
  }

  /**
   * Load highlighted collections to show on carousel.
   */
  function _loadHighlightedCollections () {
    $scope.highlightedCollections.state.loading = true
    ArtCollectionsService.getHighlightedCollections({ ...$scope.highlightedCollections.pagination })
      .then(response => {
        $scope.highlightedCollections.results = (response?.rows ?? [])
        $scope.highlightedCollections.totalCount = response.count
        api._initCarousel()
      })
      .catch(error => {
        console.log({ error })
        ToastService.showErrorToast($translate.instant('userArts.highlightedCollections.error'))
      })
      .finally(() => { $scope.highlightedCollections.state.loading = false })
  }

  /**
   * Load sections.
   */
  async function _loadSections () {
    if ($scope.sections.totalCount > 0 && $scope.sections.totalCount < $scope.sections.pagination.section.skip) return
    $scope.sections.state.loading = true
    try {
      const response = await ArtCollectionsService.getArtSections({ top: $scope.sections.pagination.section.top, skip: $scope.sections.pagination.section.skip })
      $scope.sections.totalCount = response.count
      $scope.sections.pagination.section.skip += response?.rows?.length ?? 0
      $scope.sections.presentationOrder = [...($scope.sections.presentationOrder ?? []), ...(response?.rows?.map(section => section.id) ?? [])]
      const promises = response?.rows?.map(section => api._loadSectionValues(section))
      await $q.all(promises)
    } catch (error) {
      console.log({ error })
      ToastService.showErrorToast($translate.instant('userArts.sections.error'))
    } finally {
      $timeout(() => {
        $scope.sections.state.loading = false

        if ($stateParams.damRedirect) {
          api._handleDamMigrationRedirect()
        }
      }, 100, true)
    }
  }

  /**
   * Load section collections and templates.
   */
  async function _loadSectionValues (section) {
    if (!section.id) return

    const currentSection = $scope.sections.results[section.id]
    if (currentSection?.id) {
      $scope.sections.results[section.id].loading = true
    }
    const [templates, collections] = await $q
      .all([
        api._getSectionValues({ sectionId: section.id, type: SECTION_CONTENT_TYPE.TEMPLATES, callback: ArtCollectionsService.getTemplatesById }),
        api._getSectionValues({ sectionId: section.id, type: SECTION_CONTENT_TYPE.COLLECTIONS, callback: ArtCollectionsService.getCollectionsById })
      ])
    $scope.$applyAsync(() => { api._normalizeSectionValues({ section: { ...section, ...(currentSection ?? {}) }, templates, collections }) })
  }

  /**
   * Load new templates to show on news section.
   */
  async function _loadNewTemplates () {
    $scope.news.state.loading = true
    try {
      const startDate = new Date()
      startDate.setDate(startDate.getDate() - 15)

      const params = {
        $top: $scope.news.pagination.$top,
        $orderBy: [{ field: 'templateScheduleDate', type: 'DESC' }, { field: 'templatePublicationDate', type: 'DESC' }],
        startDate: startDate.toISOString()
      }
      const response = await ArtsService.getRecentTemplates(params)
      $scope.news.results = (response?.rows ?? [])
      $scope.news.totalCount = response.count
    } catch (error) {
      console.log({ error })
      ToastService.showErrorToast($translate.instant('userArts.news.error'))
    } finally {
      $scope.news.state.loading = false
    }
  }

  /**
   * Request section values from API.
   * @param {Object} params
   * @param {Promise<Function>} params.callback Callback to request data from API.
   * @param {String} params.sectionId Section code.
   * @param {String} params.type Section type, use SECTION_CONTENT_TYPE.
   */
  function _getSectionValues ({ type, callback, sectionId }) {
    if (!sectionId || !type || !callback) return

    const skip = $scope.sections.results[sectionId]?.[type]?.skip ?? 0
    const totalCount = $scope.sections.results[sectionId]?.[type]?.totalCount ?? 0
    if (skip > totalCount) return []

    return callback?.(sectionId, { top: $scope.sections.pagination[type].top, skip })
  }

  /**
   * Normalize section templates and collections to show on sections.
   * @param {Object} params
   * @param {Object} params.section Section.
   * @param {Object} params.templates Templates.
   * @param {Object} params.collections Collections.
   */
  function _normalizeSectionValues ({ section, templates, collections }) {
    $scope.sections.results[section.id] = {
      ...section,
      loading: false,
      isExpanded: section?.isExpanded ?? true,
      templates: {
        ...(section?.templates ?? {}),
        skip: (section?.templates?.skip ?? 0) + (templates?.rows?.length ?? 0),
        results: [...(section?.templates?.results ?? []), ...(templates?.rows ?? [])],
        totalCount: templates?.count ?? 0
      },
      collections: {
        ...(section?.collections ?? {}),
        skip: (section?.collections?.skip ?? 0) + (collections?.rows?.length ?? 0),
        results: [...(section?.collections?.results ?? []), ...(collections?.rows ?? [])],
        totalCount: collections?.count ?? 0
      }
    }
  }

  function _showSocialMediaIntegrationModal () {
    const isUser = $rootScope.isUser()
    const user = $rootScope.oUser
    const hasNotUserAccounts = !user?.socialAccounts?.length
    const isHideIntegrationModal = !LocalStorageService.get('socialMedia.integrateModalHide')

    if (isUser && isHideIntegrationModal && hasNotUserAccounts && $rootScope.isEnableSocialMedia) {
      api._openSocialMediaIntegrationUser()
    }
  }

  function _openSocialMediaIntegrationUser () {
    api.getSocialMediaIntegrationUserController().then(({ SocialMediaIntegrationUserController }) => {
      const socialMediaIntegrationUser = UdsModalService.createModal({
        controller: SocialMediaIntegrationUserController,
        modalName: 'socialMediaIntegrationUserDialog'
      })

      socialMediaIntegrationUser.open()
    })
  }

  function _openSocialMediaIntegrationUserExpiry () {
    const accounts = $rootScope.oUser?.socialAccounts || []

    if (!accounts.length) return

    const expiredAccounts = SocialMediaService.getSocialAccountsExpired(accounts)
    const isUser = $rootScope.isUser()
    const hasExpiredAccounts = expiredAccounts?.length
    const isHideExpiryModal = !LocalStorageService.get('socialMedia.expiryModalHide')

    if (isUser && hasExpiredAccounts && isHideExpiryModal && $rootScope.isEnableSocialMedia) {
      api.getSocialMediaIntegrationUserExpiryController().then(({ SocialMediaIntegrationUserExpiryController }) => {
        const socialMediaIntegrationUserExpiry = UdsModalService.createModal({
          controller: SocialMediaIntegrationUserExpiryController,
          modalName: 'socialMediaIntegrationUserExpiryDialog',
          data: {
            expiredAccounts
          }
        })

        socialMediaIntegrationUserExpiry.open()
      })
    }
  }

  async function _checkSocialMediaIntegrationStatus () {
    const status = $location.search()?.socialMediaStatus
    const isEnableSocialMedia = await $rootScope.getEnableSocialMedia(true)

    const hasNotStatus = !status
    const hasNotUserAccounts = !$rootScope?.oUser?.socialAccounts?.length

    if (hasNotStatus || hasNotUserAccounts || !isEnableSocialMedia) {
      return
    }

    const types = {
      SUCCESS: api._openSocialMediaLinked,
      ERROR: () => ToastService.showErrorToast($translate.instant('socialMedia.integrationErrorMessage'))
    }

    const showCurrentStatus = types[String(status)]

    if (showCurrentStatus) {
      showCurrentStatus()
    }
  }

  function _openSocialMediaLinked () {
    api.getSocialMediaLinkedController().then(({ SocialMediaLinkedController }) => {
      const socialMediaLinked = UdsModalService.createModal({
        controller: SocialMediaLinkedController,
        modalName: 'socialMediaLinkedDialog'
      })

      socialMediaLinked.open()
    })
  }

  function _clearSelectedTemplate (ev) {
    const isTemplateCard = ev.target.closest('template-item')

    if (!isTemplateCard && !AssetPreviewService.assetPreviewIsOpen()) {
      $timeout(() => {
        if ($scope.selectedTemplates && $scope.selectedTemplates.length > 0) {
          api._clearAllSelections($scope.selectedTemplates)
          $scope.selectedTemplates = []
        }
      })
    }
  }

  function _getSelectedTemplateSection (template) {
    if (!template || !template.artCollectionId) return []

    const sectionId = template.artCollectionId
    const section = $scope.sections.results[sectionId]

    return section?.templates?.results || []
  }

  function _handleKeyboardNavigation () {
    document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
  }

  function _handleNavigateThroughKeyboard (ev) {
    const isAssetPreviewOpen = AssetPreviewService.assetPreviewIsOpen()

    if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length) || isAssetPreviewOpen) {
      return
    }

    SelectMaterialCollectionService.handleNavigateThroughKeyboard(ev, {
      selectedTemplates: $scope.selectedTemplates,
      selectedCollections: $scope.selectedCollections,
      sections: Object.values($scope.sections.results),
      scope: $scope,
      disabledTemplatesRule: $scope.disabledTemplatesRule
    })

    api._defineDisabledTemplatesRule()
  }

  function _defineDisabledTemplatesRule () {
    $scope.disabledTemplatesRule = SelectMaterialCollectionService.getDisabledTemplatesRule($scope.selectedTemplates)
    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }
}

export { UserArtsController }
